
export const GET_ORDER= 'GET_ORDER'
export const GET_ORDER_SUCCESS= 'GET_ORDER_SUCCESS'
export const GET_ORDER_ERROR='GET_ORDER_ERROR'


export const GetOrder= (data) => ({
    type: GET_ORDER,
    payload: data
})
